import React, { Component, Fragment } from "react";
import { Grid, List, ListItem, ListItemText, ListItemIcon, Hidden, Slide } from '@material-ui/core';
import { Announcement } from '@material-ui/icons';
import Pane from './containers/Pane';
import DetailsCard from './containers/DetailsCard';
import DetailsCardModal from './containers/DetailsCardModal';
import { GeneralAlertDetail } from './GeneralAlertDetail';
import { LoadingProgress } from './containers/LoadingProgress';

import withWidth, { isWidthUp } from '@material-ui/core/withWidth';

import { Filters } from './../services/Filters';

const _filters = new Filters();

class GeneralAlerts extends Component {

  state = {
    open: false,
    enter: false,
  }

  // componentDidMount() {
  //   this.props.onRefreshData();
  // }

  componentWillUnmount() {
    this.props.onClose();
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleOnEnter = () => {
    this.setState({enter: true});
  }
  handleOffEnter = () => {
    this.setState({enter: false});
  }

  handleClose = () => {
    const transitionDelay = isWidthUp('md', this.props.width) ? 300 : 0;
    this.handleOffEnter();
    setTimeout(() => {
      this.setState({ open: false });
      this.props.onClose();
    },transitionDelay);
  };

  handleSelect = (id) => {
    this.props.onSelect(id);
    this.handleOnEnter();
    if (!isWidthUp('md', this.props.width)) {
      this.handleOpen();
    }
  }

  handleItemClick = (item) => {
    if(item.url) this.openExternalLink(item.url);
  }

  render() {
    const { 
      alerts,
      translations,
      appLanguage,
      alertItem: {
        id,
        header,
        date,
        description,
        linkto,
      },
    } = this.props;
    const { enter } = this.state;
    return (
      <Fragment>
        <Grid container spacing={24} justify='center' >
          <Grid item xs zeroMinWidth style={{maxWidth: 800}} >
            <Pane header={`General ${translations.t_TITLE_ALERTS[appLanguage]}`}>
              <LoadingProgress data={alerts}>
                <List>
                  {alerts.map(({id, header, date}) =>
                    <ListItem
                      divider
                      key={id ? id : 0}
                      button
                      onClick={() => this.handleSelect(id)}
                    >
                      <ListItemIcon><Announcement /></ListItemIcon>
                      <ListItemText
                        primary={header ? _filters.translate(header, appLanguage) : null}
                        secondary={_filters.startEndDate(date, date)}
                      />
                    </ListItem>
                  )}
                </List>
              </LoadingProgress>
            </Pane>
          </Grid>
          { id ? 
            <Fragment>
              <Hidden smDown>
                <Grid item xs lg={5}>
                  <Slide direction="left" in={enter} mountOnEnter unmountOnExit>
                    <DetailsCard
                      title={header}
                      appLanguage={appLanguage}
                      subheader={_filters.startEndDate(date)}
                      onClose={this.handleClose}
                    >
                      <GeneralAlertDetail
                        description={_filters.translate(description, appLanguage)}
                        linkto={linkto}
                      />
                    </DetailsCard>
                  </Slide>
                </Grid>
              </Hidden>
              <DetailsCardModal
                ariaLabelledby="contact-modal-title"
                ariaDescribedby="contact-modal-description"
                open={this.state.open}
                onClose={this.handleClose}
                appLanguage={appLanguage}
                title={header} subheader={_filters.startEndDate(date)}
              >
                <GeneralAlertDetail
                  description={_filters.translate(description, appLanguage)}
                  linkto={linkto}
                />
              </DetailsCardModal>
            </Fragment>
            : null
          }
        </Grid>
      </Fragment>
    )
  }
}

export default withWidth()(GeneralAlerts);


// WEBPACK FOOTER //
// ./src/components/GeneralAlerts.js